import { light as baseTheme } from '@eva-design/eva';
import colors from './colors';
import mappings from './mappings';
import baseMappings from './cutover.json';
import tokens from './tokens';
import fontLoader from '../../loaders/font/font';
import latoFont from '../../fonts/Lato';
import oswaldFont from '../../fonts/Oswald';
import poppinsFont from '../../fonts/Poppins';
import ptSerifFont from '../../fonts/PT_Serif';
import materialCommunityIconsFont from '../../fonts/MaterialCommunityIcons';
const theme = {
    ...baseTheme,
    ...colors,
    ...tokens,
};
/* NOTE: these fonts gets fetched when requested. For offline mode, any new font in Beacon needs to be added
*        to /src/worker/setupRoutes.ts, so they can be precached.  */
const loaders = [
    fontLoader(latoFont),
    fontLoader(oswaldFont),
    fontLoader(poppinsFont),
    fontLoader(ptSerifFont),
    fontLoader(materialCommunityIconsFont),
];
export default {
    theme,
    baseMappings,
    mappings,
    loaders,
};
//# sourceMappingURL=config.js.map